/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EpisodeOfCare } from './EpisodeOfCare';
import {
    EpisodeOfCareFromJSON,
    EpisodeOfCareFromJSONTyped,
    EpisodeOfCareToJSON,
    EpisodeOfCareToJSONTyped,
} from './EpisodeOfCare';

/**
 * 
 * @export
 * @interface FindPatientEpisodesOfCare200Response
 */
export interface FindPatientEpisodesOfCare200Response {
    /**
     * 
     */
    data?: Array<EpisodeOfCare>;
}

/**
 * Check if a given object implements the FindPatientEpisodesOfCare200Response interface.
 */
export function instanceOfFindPatientEpisodesOfCare200Response(value: object): value is FindPatientEpisodesOfCare200Response {
    return true;
}

export function FindPatientEpisodesOfCare200ResponseFromJSON(json: any): FindPatientEpisodesOfCare200Response {
    return FindPatientEpisodesOfCare200ResponseFromJSONTyped(json, false);
}

export function FindPatientEpisodesOfCare200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindPatientEpisodesOfCare200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(EpisodeOfCareFromJSON)),
    };
}

export function FindPatientEpisodesOfCare200ResponseToJSON(json: any): FindPatientEpisodesOfCare200Response {
    return FindPatientEpisodesOfCare200ResponseToJSONTyped(json, false);
}

export function FindPatientEpisodesOfCare200ResponseToJSONTyped(value?: FindPatientEpisodesOfCare200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(EpisodeOfCareToJSON)),
    };
}

